

































































import Vue from 'vue';
import {
  calender,
  item,
  Item,
  brand,
  Brand,
} from 'mostra';

import * as page from '@/modules/page';
const pageParams = page.tabParams.item;

interface DataType {
  loading: boolean;
  targetPageName: string;
  editPageName: string;
  item: Item | null;
  brands: Brand[];
  notFound: boolean;
  owner: string | null;
}

export default Vue.extend({
  name: 'exhibitor-item',
  data(): DataType {
    return {
      loading: true,
      targetPageName: 'admin-admin-item-edit',
      editPageName: 'admin-admin-item-edit',
      item: null,
      brands: [],
      // currentPage: '',
      notFound: false,
      owner: null,
    };
  },
  computed: {
    itemId(): string | null {
      return this.$route.query.id as string;
    },
    currentPage() {
      return this.$route.query.page as string;
    },
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async onClickSave() {
      try {
        this.$loading(true);
        this.loading = true;
        if (!this.item) {
          throw Error('this.item is null');
        }

        this.item = await item.save(this.$auth.uid, this.item);

        this.$success('保存しました。');
        this.$router.push({
          name: this.editPageName,
          query: {
            page: 'preview',
            id: this.item.id,
          },
        });
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);

        if (!this.itemId) {
          throw Error('can not get id');
        }

        if (this.item) return;

        this.item = await item.load(this.itemId);

        if (!this.item) {
          this.notFound = true;
          return;
        }
        this.owner = this.item.data.owner;
        this.brands = await brand.loadsByOwner(this.owner);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    checkQueryParamsValid() {
      if (!this.currentPage || !pageParams.includes(this.currentPage)) {
        this.$router.replace({
          name: this.targetPageName,
          query: {
            ...this.$route.query,
            page: 'preview',
          },
        });
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    this.checkQueryParamsValid();
    await this.fetchData();
  },
  async mounted() {
    this.checkQueryParamsValid();
    await this.fetchData();
  },
});
